import React, { useState, useEffect, useRef } from 'react';
import cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Notifications from '../notifications/notifications';
import * as notificationActions from '../../redux/notifications/actions';
import './header.scss';

const Header = props => {
  const notifMusic = new Audio('/sound.mp3');
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [notificationsFlag, setNotificationsFlag] = useState(false);
  const { firstName, lastName } = useSelector(state => state.authReducer.meInfo);
  const { notificationsList } = useSelector(state => state.notificationsReducer);
  const {
    getUnreadNotificationLoading: unreadNotificationLoading,
    getUnreadNotificationFailed: unreadNotificationFailed,
    getUnreadNotificationError: unreadNotificationError,
    getUnreadNotificationMessage: unreadNotificationMessage
  } = useSelector(state => state.notificationsReducer);

  const notificationsRef = useRef();
  const wrapperRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(notificationActions.getMyUnreadNotification());
  }, []);

  useEffect(() => {
    function handleClickOutsideWrapper(e) {
      if (wrapperRef.current) {
        if (!wrapperRef.current.contains(e.target)) {
          setPopUpFlag(false);
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutsideWrapper);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideWrapper);
    };
  }, [wrapperRef]);

  useEffect(() => {
    function handleClickOutSideNotif(e) {
      if (notificationsRef.current) {
        if (!notificationsRef.current.contains(e.target)) {
          setNotificationsFlag(false);
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutSideNotif);
    return () => {
      document.removeEventListener('mousedown', handleClickOutSideNotif);
    };
  }, [notificationsRef]);

  useEffect(() => {
    if (notificationsList.length > 0) {
      notifMusic.play();
    }
  }, [notificationsList.length]);

  const toggleUserMenu = () => setPopUpFlag(!popUpFlag);

  const toggleNotificationMenu = () => setNotificationsFlag(!notificationsFlag);

  const handleClearAllNotification = () => {
    let cafeIds = notificationsList.map(notification => notification.id);
    cafeIds = { ids: cafeIds };
    dispatch(notificationActions.putMyReadNotification(cafeIds));
  };

  const logOut = event => {
    event.preventDefault();
    cookies.remove('auth-token');
    props.history.push('/login');
  };

  return (
    <header className="app-header">
      <div className="app-header__inner container">
        <div className="app-header__logo">
          <Link to="/" className="app-header__logo-desktop">
            {locales('titles.rsee')}
          </Link>
        </div>
        <div className="app-header__icons">
          <div className="app-header__notification-icon rsee-dropdown" ref={notificationsRef}>
            <a className="app-header__nav-link-icon rsee-dropdown__toggle" onClick={toggleNotificationMenu}>
              <i className="fal fa-bell"></i>
              {notificationsList && notificationsList.length ? <span className="pulse"></span> : null}
            </a>
            {notificationsFlag && notificationsList && notificationsList.length ? (
              <div className="rsee-dropdown__menu rsee-dropdown__menu--arrow">
                <Notifications
                  notificationsList={notificationsList}
                  onClearAllNotification={handleClearAllNotification}
                />
              </div>
            ) : null}
          </div>
          <div className="app-header__user-icon--container" ref={wrapperRef}>
            <div className="app-header__user-icon rsee-dropdown">
              <a className="app-header__nav-link-icon rsee-dropdown__toggle" onClick={toggleUserMenu}>
                <img
                  className="app-header__user-avatar"
                  src={props.meInfo.avatar || require('../../assets/icons/userDefault.png')}
                />
              </a>
              {popUpFlag && (
                <div className="rsee-dropdown__menu rsee-dropdown__menu--arrow">
                  <div className="rsee-dropdown__header">
                    <h5>{`${firstName} ${lastName}`}</h5>
                    <p>
                      {props.meInfo.selectedRole.title + ' ' + (props.meInfo.selectedRole.cafeName || '')}
                    </p>
                  </div>
                  <a href="#" className="rsee-dropdown__item">
                    <i className="fal fa-user"></i>
                    {locales('titles.profile')}
                  </a>
                  <Link
                    to="/change-password"
                    className="rsee-dropdown__item"
                    onClick={() => {
                      setPopUpFlag(false);
                    }}
                  >
                    <i className="fal fa-key"></i>
                    {locales('titles.changePassword')}
                  </Link>
                  <a href="#" className="rsee-dropdown__item" onClick={logOut}>
                    <i className="fal fa-sign-out"></i>
                    {locales('titles.logout')}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
